/* Putzkopf – Hero „Zeitreise“: Kauwurzel → Knochenbürste → Nylonbürste → erste Elektrische → heute
   Fünf gezeichnete Szenen liegen nebeneinander. In der ersten steht die Figur aus dem Bett auf und
   putzt am Spiegel; danach läuft sie ohne Schnitt weiter in die nächste Epoche, die Kamera geht mit. */
(() => {
  'use strict';
  const root = document.getElementById('zeitreise');
  if (!root) return;

  /* ---------- Figur (im Profil, Blick nach rechts; Fußpunkt = 0,0) ---------- */
  function person(o) {
    const sk = o.skin, skD = o.skinDark, walk = o.pose === 'walk';
    const hair = {
      wrap: `<path d="M-40,-360 Q-34,-404 10,-404 Q54,-404 58,-362 Q60,-350 50,-352 Q40,-392 6,-390 Q-26,-388 -30,-346 Q-40,-330 -46,-300 L-54,-302 Q-50,-340 -40,-360Z" fill="${o.hairC}"/>
             <path d="M-36,-372 Q10,-380 56,-366" stroke="${o.band}" stroke-width="7" fill="none" stroke-linecap="round"/>`,
      side: `<path d="M-38,-350 Q-40,-398 8,-400 Q50,-402 56,-370 Q40,-384 14,-382 Q-4,-376 -12,-366 Q-22,-356 -26,-336 Z" fill="${o.hairC}"/>
             <path d="M14,-382 Q36,-392 54,-374" stroke="#fff" stroke-opacity=".25" stroke-width="3" fill="none"/>`,
      wig: `<path d="M-60,-344 Q-66,-326 -60,-300" stroke="${o.hairC}" stroke-width="11" stroke-linecap="round" fill="none"/>
             <path d="M-60,-348 q-14,-10 -14,2 q0,10 14,-2z M-60,-348 q14,-10 14,2 q0,10 -14,-2z M-62,-346 l-4,16 M-58,-346 l4,16" fill="${o.band}" stroke="${o.band}" stroke-width="3" stroke-linecap="round"/>
             <path d="M-44,-350 Q-48,-404 6,-406 Q54,-406 60,-364 Q50,-386 20,-388 Q-14,-388 -28,-350 Z" fill="${o.hairC}"/>
             <ellipse cx="-26" cy="-338" rx="13" ry="9" fill="${o.hairC}" stroke="#ddd6c8" stroke-width="2"/>
             <ellipse cx="-28" cy="-318" rx="12" ry="8" fill="${o.hairC}" stroke="#ddd6c8" stroke-width="2"/>`,
      quiff: `<path d="M-38,-344 Q-44,-392 -6,-404 Q20,-418 46,-402 Q62,-392 54,-376 Q36,-384 20,-380 Q-10,-374 -24,-334 Z" fill="${o.hairC}"/>
              <path d="M-38,-344 Q-40,-330 -34,-318" stroke="${o.hairC}" stroke-width="8" stroke-linecap="round" fill="none"/>`
    }[o.hair];
    const beard = o.beard ? `<path d="M-6,-330 Q4,-292 34,-296 Q52,-300 54,-318 Q46,-312 40,-314 Q34,-308 24,-312 Q8,-312 -6,-330Z" fill="${o.hairC}" opacity=".92"/>` : '';
    const glasses = o.glasses ? `<g fill="none" stroke="#2b1a12" stroke-width="3.2"><circle cx="34" cy="-357" r="12"/><path d="M22,-359 L-8,-356"/></g>` : '';
    const stache = o.stache ? `<path d="M34,-326 Q44,-334 54,-326" stroke="${o.hairC}" stroke-width="6" stroke-linecap="round" fill="none"/>` : '';
    const legs = o.robe
      ? `<g class="robe"><path d="M-50,-290 Q-62,-150 -68,-10 L64,-10 Q56,-150 42,-290 Z" fill="${o.top}"/>
         <path d="M-20,-200 Q-26,-100 -30,-12" stroke="${o.topShade}" stroke-width="4" fill="none" opacity=".5"/>
         <path d="M14,-210 Q22,-110 26,-12" stroke="${o.topShade}" stroke-width="4" fill="none" opacity=".5"/></g>
         <g class="footA"><ellipse cx="-24" cy="-6" rx="24" ry="8" fill="#8a5a33"/></g><g class="footB"><ellipse cx="26" cy="-6" rx="24" ry="8" fill="#8a5a33"/></g>`
      : `<g class="legA"><rect x="-32" y="-168" width="32" height="164" rx="14" fill="${o.bottomShade}"/>${o.stockings ? `<rect x="-30" y="-94" width="28" height="88" rx="10" fill="${o.stockings}"/>` : ''}<ellipse cx="-14" cy="-6" rx="26" ry="9" fill="${o.shoe}"/>${o.buckle ? `<rect x="-14" y="-14" width="10" height="7" rx="2" fill="#e2b84a"/>` : ''}</g>
         <g class="legB"><rect x="-2" y="-168" width="34" height="164" rx="14" fill="${o.bottom}"/>${o.stockings ? `<rect x="0" y="-94" width="30" height="88" rx="10" fill="${o.stockings}"/>` : ''}<ellipse cx="24" cy="-6" rx="28" ry="9" fill="${o.shoe}"/>${o.buckle ? `<rect x="26" y="-14" width="10" height="7" rx="2" fill="#e2b84a"/>` : ''}</g>`;
    const torso = o.robe ? '' :
      `<path d="M-48,-294 Q-54,-210 -46,-150 L46,-150 Q52,-210 42,-294 Q0,-314 -48,-294Z" fill="${o.top}"/>
       ${o.suspenders ? `<path d="M-30,-296 L-22,-150 M26,-298 L18,-150" stroke="${o.suspenders}" stroke-width="7"/>` : ''}
       ${o.hood ? `<path d="M-46,-296 Q-60,-330 -30,-318 Q-10,-306 -6,-296" fill="${o.topShade}"/><path d="M8,-290 L4,-240 M20,-288 L22,-244" stroke="#fff" stroke-width="3" stroke-linecap="round" opacity=".8"/>` : ''}
       ${o.vest ? `<path d="M-6,-292 L32,-294 L30,-160 L-4,-160Z" fill="${o.vest}"/><g fill="#8a6a2a"><circle cx="14" cy="-250" r="3"/><circle cx="14" cy="-222" r="3"/><circle cx="14" cy="-194" r="3"/></g>` : ''}
       ${o.jabot ? `<path d="M16,-304 q-10,14 2,24 q-12,10 2,20 q12,-6 8,-20 q10,-12 -12,-24z" fill="#fffdf7" stroke="#e6dfd0" stroke-width="2"/>` : ''}
       ${o.collar ? `<path d="M-6,-300 L12,-282 L26,-300" stroke="#f7f3ea" stroke-width="7" fill="none" stroke-linejoin="round"/>` : ''}
       <path d="M-46,-160 L46,-160" stroke="${o.topShade}" stroke-width="10" opacity=".55"/>`;
    const backArm = `<g class="armB"><path d="M-24,-282 Q-36,-220 -32,-168" stroke="${o.robe ? o.topShade : (o.shortSleeve ? sk : o.topShade)}" stroke-width="24" stroke-linecap="round" fill="none"/>
      <circle cx="-32" cy="-160" r="12" fill="${skD}"/></g>`;
    return `
      <ellipse cx="0" cy="0" rx="78" ry="10" fill="#000" opacity=".12"/>
      <g class="bob">
      ${legs}${backArm}${torso}
      <rect x="-4" y="-318" width="26" height="30" rx="8" fill="${skD}"/>
      <circle cx="8" cy="-348" r="46" fill="${sk}"/>
      <ellipse cx="54" cy="-344" rx="10" ry="8" fill="${sk}"/>
      <ellipse cx="-12" cy="-344" rx="9" ry="12" fill="${skD}"/>
      <circle cx="30" cy="-326" r="9" fill="#ff8f70" opacity=".35"/>
      <circle cx="32" cy="-358" r="4.4" fill="#2b1a12"/>
      <path d="M22,-372 Q32,-378 42,-372" stroke="#2b1a12" stroke-width="3.4" stroke-linecap="round" fill="none"/>
      ${hair}${beard}${stache}${glasses}
      ${walk ? `<path d="M38,-322 q8,5 16,0" stroke="#7a2e22" stroke-width="3.4" stroke-linecap="round" fill="none"/>` : `<ellipse cx="46" cy="-322" rx="7" ry="5" fill="#7a2e22"/>`}
      ${walk ? walkArm(o) : `<path d="M12,-288 Q30,-262 50,-226" stroke="${o.top}" stroke-width="27" stroke-linecap="round" fill="none"/>${o.pose === 'pre' ? preArm(o) : brushArm(o)}`}
      </g>`;
  }
  function tool(t) {
    if (t === 'miswak') return `
      <rect x="40" y="-327" width="96" height="11" rx="5" fill="#8b5a2b"/>
      <path d="M48,-327 L136,-327" stroke="#6d4320" stroke-width="2" opacity=".6"/>
      <path d="M40,-322 l-9,-7 M40,-322 l-10,-2 M40,-322 l-10,3 M40,-322 l-8,7" stroke="#e8c48c" stroke-width="2.4" stroke-linecap="round"/>`;
    if (t === 'bone') return `
      <rect x="54" y="-326" width="92" height="9" rx="4.5" fill="#efe4c8" stroke="#cdbb93" stroke-width="1.5"/>
      <rect x="44" y="-325" width="18" height="7" rx="3" fill="#efe4c8" stroke="#cdbb93" stroke-width="1.5"/>
      <path d="M45,-326 v-7 M49,-326 v-8 M53,-326 v-8 M57,-326 v-7" stroke="#3a2a20" stroke-width="2.6" stroke-linecap="round"/>`;
    if (t === 'retro') return `
      <path d="M160,-322 q34,8 24,40 q-10,34 22,56" stroke="#6b5a48" stroke-width="3" fill="none"/>
      <rect x="66" y="-335" width="96" height="26" rx="9" fill="#efe2c4" stroke="#bfa98a" stroke-width="2"/>
      <rect x="74" y="-328" width="22" height="12" rx="3" fill="#c0483f"/>
      <rect x="40" y="-326" width="30" height="8" rx="3" fill="#fbf7f2" stroke="#d8cbbd" stroke-width="1.5"/>
      <path d="M43,-326 v-7 M47,-326 v-7 M51,-326 v-7" stroke="#fff" stroke-width="2.4" stroke-linecap="round"/>`;
    if (t === 'hand') return `
      <rect x="54" y="-326" width="92" height="9" rx="4.5" fill="#d9483b"/>
      <rect x="44" y="-325" width="18" height="7" rx="3" fill="#d9483b"/>
      <path d="M45,-326 v-7 M49,-326 v-8 M53,-326 v-8 M57,-326 v-7" stroke="#fffaf0" stroke-width="2.6" stroke-linecap="round"/>`;
    return `
      <rect x="70" y="-332" width="96" height="20" rx="10" fill="#fbf7f2" stroke="#d8cbbd" stroke-width="2"/>
      <circle cx="98" cy="-322" r="4" fill="#ef7d45" class="ring"/>
      <rect x="40" y="-326" width="34" height="8" rx="4" fill="#fbf7f2" stroke="#d8cbbd" stroke-width="1.5"/>
      <rect x="40" y="-332" width="12" height="9" rx="3" fill="#ef7d45"/>`;
  }
  // Beim Gehen hängt der vordere Arm locker herab und hält das Putzwerkzeug
  function walkArm(o) {
    const held = {
      miswak: `<rect x="14" y="-196" width="11" height="80" rx="5" fill="#8b5a2b"/><path d="M19,-116 l-6,9 M19,-116 l0,10 M19,-116 l6,9" stroke="#e8c48c" stroke-width="2.4" stroke-linecap="round"/>`,
      hand: `<rect x="15" y="-200" width="9" height="84" rx="4.5" fill="#d9483b"/><path d="M14,-118 h-7 M14,-114 h-8 M14,-110 h-7" stroke="#fffaf0" stroke-width="2.6" stroke-linecap="round"/>`,
      bone: `<rect x="15" y="-200" width="9" height="84" rx="4.5" fill="#efe4c8" stroke="#cdbb93" stroke-width="1.5"/><path d="M14,-118 h-7 M14,-114 h-8 M14,-110 h-7" stroke="#3a2a20" stroke-width="2.6" stroke-linecap="round"/>`,
      retro: `<rect x="8" y="-204" width="22" height="94" rx="8" fill="#efe2c4" stroke="#bfa98a" stroke-width="2"/><rect x="13" y="-182" width="12" height="20" rx="3" fill="#c0483f"/>`,
      electric: `<rect x="9" y="-200" width="20" height="90" rx="10" fill="#fbf7f2" stroke="#d8cbbd" stroke-width="2"/><circle cx="19" cy="-176" r="4" fill="#ef7d45"/>`
    }[o.tool];
    return `<g class="armA">
      <path d="M8,-284 Q16,-232 18,-176" stroke="${o.top}" stroke-width="26" stroke-linecap="round" fill="none"/>
      ${o.shortSleeve ? `<path d="M15,-234 Q18,-204 19,-176" stroke="${o.skin}" stroke-width="22" stroke-linecap="round" fill="none"/>` : ''}
      ${held}
      <circle cx="19" cy="-168" r="13" fill="${o.skin}"/>
    </g>`;
  }
  function brushArm(o) {
    return `<g class="brushing ${o.tool === 'electric' || o.tool === 'retro' ? 'fast' : ''}">
      <path d="M50,-226 Q72,-270 86,-318" stroke="${o.shortSleeve ? o.skin : o.top}" stroke-width="23" stroke-linecap="round" fill="none"/>
      ${tool(o.tool)}
      <circle cx="88" cy="-322" r="14" fill="${o.skin}"/>
      <path d="M80,-312 q8,4 16,0" stroke="${o.skinDark}" stroke-width="3" fill="none" stroke-linecap="round"/>
      ${o.tool === 'electric' ? `<g class="vib"><path d="M30,-344 q-12,22 0,44" /><path d="M20,-352 q-18,30 0,60"/><path d="M10,-360 q-24,38 0,76"/></g>` : ''}
    </g>`;
  }
  function preArm(o) {
    return `<g class="prearm">
      <path d="M50,-226 Q78,-214 96,-206" stroke="${o.top}" stroke-width="23" stroke-linecap="round" fill="none"/>
      <rect x="88" y="-262" width="20" height="96" rx="10" fill="#fbf7f2" stroke="#d8cbbd" stroke-width="2"/>
      <circle cx="98" cy="-236" r="4" fill="#ef7d45"/>
      <g class="ehead"><rect x="94" y="-300" width="8" height="38" rx="4" fill="#fbf7f2" stroke="#d8cbbd" stroke-width="1.5"/><rect x="92" y="-306" width="12" height="14" rx="4" fill="#ef7d45"/></g>
      <circle cx="98" cy="-206" r="14" fill="${o.skin}"/>
      <text x="124" y="-292" class="klick">Klick!</text>
    </g>`;
  }

  /* ---------- Schlafende Figur: Kopf auf dem Kissen, Blick nach oben ---------- */
  function sleeper(o, x, y) {
    const hairC = o.hair === 'wrap' ? o.hairC : o.hairC;
    return `<g class="sleeper" transform="translate(${x},${y})">
      <circle r="40" fill="${o.skin}"/>
      <path d="M-6,-40 A40,40 0 0 0 -6,40 Q-30,0 -6,-40Z" fill="${hairC}"/>
      ${o.hair === 'wrap' ? `<path d="M-14,-37 Q-22,0 -14,37" stroke="${o.band}" stroke-width="6" fill="none"/>` : ''}
      <ellipse cx="6" cy="-42" rx="8" ry="10" fill="${o.skin}"/>
      <path d="M12,-14 q8,6 16,0" stroke="#2b1a12" stroke-width="3.4" stroke-linecap="round" fill="none"/>
      <circle cx="26" cy="4" r="7" fill="#ff8f70" opacity=".35"/>
      ${o.beard ? `<path d="M18,14 Q36,10 38,-4 Q44,18 26,30 Q16,30 18,14Z" fill="${o.hairC}" opacity=".9"/>` : ''}
      ${o.stache ? `<path d="M32,-10 q8,6 4,14" stroke="${o.hairC}" stroke-width="5" stroke-linecap="round" fill="none"/>` : ''}
      <g class="zzz"><text x="40" y="-50">z</text><text x="62" y="-82">z</text><text x="88" y="-118">Z</text></g>
    </g>`;
  }

  /* ---------- Szenen (Kernbild 1200 × 700, Boden bei y = 600; Bett links, Spiegel rechts) ---------- */
  const MX = 965;           // Spiegelmitte
  const PX = 700;           // Platz der Figur am Spiegel
  const SX = 190;           // Startpunkt neben dem Bett
  const BG = 'x="-800" y="-700" width="2800" height="1400"';   // Hintergrund großzügig für jede Bildschirmbreite
  const reflect = (clip) => `<g class="refl" clip-path="url(#${clip})"><g opacity=".78" transform="translate(${MX + 7},640) scale(-.92,.92)"><g class="rfig"></g></g><rect x="${MX - 150}" y="150" width="300" height="360" fill="#fff" opacity=".12"/></g>`;
  const who = () => `<g class="who" transform="translate(${SX},600)"><g class="fig"></g></g>`;

  const man1 = { skin: '#c98a5c', skinDark: '#ad6f45', hair: 'wrap', hairC: '#f4ece0', band: '#b5473a', beard: true, robe: true, top: '#f7efe2', topShade: '#d9c7ad', tool: 'miswak' };
  const man2 = { skin: '#f0c19c', skinDark: '#d69d77', hair: 'side', hairC: '#3a2418', stache: true, top: '#fffaf1', topShade: '#e6d8c4', shortSleeve: true, suspenders: '#8c3b2e', bottom: '#6b4a36', bottomShade: '#57392a', shoe: '#2f1d14', tool: 'hand' };
  const man3 = { skin: '#d9a07a', skinDark: '#bf8460', hair: 'quiff', hairC: '#2b1a12', beard: true, hood: true, top: '#ef7d45', topShade: '#d0602c', bottom: '#3d5a80', bottomShade: '#30496a', shoe: '#f3eee8', tool: 'electric' };

  const sc1 = `
  <svg viewBox="-350 -300 1700 1000" preserveAspectRatio="xMidYMax slice" aria-hidden="true">
    <defs>
      <linearGradient id="sky1" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#ffe2b4"/><stop offset=".65" stop-color="#f7a46b"/><stop offset="1" stop-color="#f08a57"/></linearGradient>
      <radialGradient id="sun1"><stop offset="0" stop-color="#fff2c9"/><stop offset=".55" stop-color="#ffe0a0"/><stop offset="1" stop-color="#ffe0a0" stop-opacity="0"/></radialGradient>
      <radialGradient id="bronze" cx=".4" cy=".35"><stop offset="0" stop-color="#ffe7b0"/><stop offset=".6" stop-color="#e2ad5e"/><stop offset="1" stop-color="#b9792f"/></radialGradient>
      <pattern id="weave" width="18" height="18" patternUnits="userSpaceOnUse"><rect width="18" height="18" fill="#d9b47c"/><path d="M0,0 L18,18 M18,0 L0,18" stroke="#b88a4e" stroke-width="3"/></pattern>
      <clipPath id="clip1"><circle cx="${MX}" cy="330" r="100"/></clipPath>
    </defs>
    <rect ${BG} fill="url(#sky1)"/>
    <circle cx="420" cy="250" r="190" fill="url(#sun1)"/><circle cx="420" cy="250" r="78" fill="#fff0c4"/>
    <g class="birds" fill="none" stroke="#9b4b2c" stroke-width="3" stroke-linecap="round"><path d="M560,120 q10,-10 20,0 q10,-10 20,0"/><path d="M630,90 q8,-8 16,0 q8,-8 16,0"/></g>
    <path d="M-800,470 Q-400,420 0,460 Q200,400 420,450 T860,430 T1200,440 Q1500,450 2000,430 V700 H-800Z" fill="#f2b67c"/>
    <path d="M-800,520 Q-300,480 0,520 Q260,470 520,515 T1200,500 Q1600,490 2000,510 V700 H-800Z" fill="#e79c5d"/>
    <g transform="translate(470,600)">
      <path d="M0,0 Q-8,-120 14,-250" stroke="#8a5530" stroke-width="16" fill="none" stroke-linecap="round"/>
      <g fill="#5f7a3a"><path d="M14,-250 q-80,-10 -120,40 q60,-30 120,-40"/><path d="M14,-250 q70,-30 130,10 q-70,-14 -130,-10"/><path d="M14,-250 q-30,-70 -100,-80 q60,30 100,80"/><path d="M14,-250 q40,-60 110,-60 q-60,20 -110,60"/></g>
      <circle cx="10" cy="-240" r="9" fill="#8a4a24"/><circle cx="22" cy="-236" r="8" fill="#8a4a24"/>
    </g>
    <rect x="-800" y="600" width="2800" height="200" fill="#dc8d52"/>
    <path d="M-800,612 Q300,604 600,616 T2000,610" stroke="#c97a42" stroke-width="3" fill="none"/>
    <!-- Charpai: geflochtenes Holzbett -->
    <g>
      <rect x="-250" y="520" width="16" height="80" fill="#7a4a26"/><rect x="104" y="520" width="16" height="80" fill="#7a4a26"/>
      <rect x="-262" y="500" width="394" height="26" rx="8" fill="url(#weave)" stroke="#8a5530" stroke-width="8"/>
      <rect x="-236" y="470" width="96" height="36" rx="16" fill="#f3e3c3"/>
      <g class="blanket-on"><path d="M-150,500 Q-140,446 -60,452 Q20,446 60,470 Q110,470 124,500Z" fill="#b5473a"/><path d="M-120,470 Q-40,462 40,474 M-140,486 Q-40,478 100,490" stroke="#f2b544" stroke-width="5" fill="none"/></g>
      <g class="blanket-off"><path d="M40,500 Q46,470 80,472 Q118,474 124,500Z" fill="#b5473a"/><path d="M52,486 Q90,480 118,490" stroke="#f2b544" stroke-width="5" fill="none"/></g>
    </g>
    ${sleeper(man1, -188, 452)}
    <g transform="translate(${MX},0)">
      <rect x="-10" y="420" width="20" height="180" fill="#8a5530"/><rect x="-60" y="590" width="120" height="14" rx="6" fill="#6f4224"/>
      <circle cx="0" cy="330" r="112" fill="#9c6227"/><circle cx="0" cy="330" r="100" fill="url(#bronze)"/>
    </g>
    ${reflect('clip1')}
    <circle cx="${MX - 30}" cy="290" r="40" fill="#fff" opacity=".18"/>
    <g transform="translate(840,600)"><path d="M-22,0 q-10,-40 6,-56 q-6,-10 4,-14 h24 q10,4 4,14 q16,16 6,56z" fill="#b5603a"/><path d="M-18,-40 h36" stroke="#8a4024" stroke-width="3"/></g>
    ${who()}
  </svg>`;

  const sc2 = `
  <svg viewBox="-350 -300 1700 1000" preserveAspectRatio="xMidYMax slice" aria-hidden="true">
    <defs>
      <pattern id="tiles" width="40" height="40" patternUnits="userSpaceOnUse"><rect width="40" height="40" fill="#f6d58e"/><path d="M0,0 H40 M0,0 V40" stroke="#e7b964" stroke-width="3"/></pattern>
      <pattern id="floor2" width="60" height="60" patternUnits="userSpaceOnUse"><rect width="60" height="60" fill="#f2dcb8"/><rect width="30" height="30" fill="#c97a4c"/><rect x="30" y="30" width="30" height="30" fill="#c97a4c"/></pattern>
      <pattern id="paper" width="36" height="36" patternUnits="userSpaceOnUse"><rect width="36" height="36" fill="#fbe8c6"/><circle cx="18" cy="18" r="3" fill="#f0c98a"/></pattern>
      <pattern id="quilt" width="44" height="44" patternUnits="userSpaceOnUse"><rect width="44" height="44" fill="#7d9cc0"/><rect width="22" height="22" fill="#e6a0a0"/><rect x="22" y="22" width="22" height="22" fill="#f4e2c0"/></pattern>
      <linearGradient id="glass2" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#fff6e6"/><stop offset="1" stop-color="#ead8bd"/></linearGradient>
      <linearGradient id="town" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#ffe2b0"/><stop offset="1" stop-color="#f7b984"/></linearGradient>
      <clipPath id="clip2"><ellipse cx="${MX}" cy="315" rx="96" ry="122"/></clipPath>
    </defs>
    <rect ${BG} fill="url(#paper)"/>
    <rect x="-800" y="380" width="2800" height="220" fill="url(#tiles)"/>
    <rect x="-800" y="372" width="2800" height="12" fill="#c97a4c"/>
    <g transform="translate(-200,110)">
      <rect width="250" height="220" rx="8" fill="url(#town)"/>
      <g fill="#c77b51"><rect x="10" y="150" width="50" height="70"/><path d="M5,152 l30,-30 l30,30z"/><rect x="80" y="120" width="26" height="100"/><path d="M78,122 l15,-60 l15,60z"/><rect x="130" y="160" width="70" height="60"/><path d="M125,162 l40,-28 l40,28z"/></g>
      <g fill="#ffe9b8"><rect x="22" y="170" width="10" height="12"/><rect x="150" y="178" width="10" height="12"/><rect x="176" y="178" width="10" height="12"/></g>
      <rect width="250" height="220" rx="8" fill="none" stroke="#9c5a32" stroke-width="12"/>
      <path d="M125,0 V220 M0,110 H250" stroke="#9c5a32" stroke-width="8"/>
      <rect x="-14" y="216" width="278" height="14" rx="4" fill="#8a4a2a"/>
    </g>
    <g transform="translate(470,250)">
      <rect x="0" y="60" width="140" height="10" rx="3" fill="#8a4a2a"/>
      <rect x="10" y="20" width="56" height="40" rx="8" fill="#b5473a"/><circle cx="26" cy="40" r="10" fill="#f6d58e"/><rect x="40" y="30" width="20" height="4" fill="#f6d58e"/><rect x="40" y="40" width="20" height="4" fill="#f6d58e"/><path d="M50,20 l12,-22" stroke="#2b1a12" stroke-width="3"/>
      <rect x="90" y="30" width="22" height="30" rx="4" fill="#cfe6e3" opacity=".9"/>
    </g>
    <rect x="-800" y="600" width="2800" height="200" fill="url(#floor2)"/>
    <!-- Eisenbett mit Messingknäufen -->
    <g>
      <path d="M-262,600 V380 M-226,600 V380" stroke="#3a2a24" stroke-width="10"/>
      <path d="M-262,392 Q-244,360 -226,392" stroke="#3a2a24" stroke-width="10" fill="none"/>
      <path d="M-252,420 V500 M-236,420 V500" stroke="#3a2a24" stroke-width="5"/>
      <circle cx="-262" cy="376" r="9" fill="#d9a441"/><circle cx="-226" cy="376" r="9" fill="#d9a441"/>
      <path d="M112,600 V440 M136,600 V440" stroke="#3a2a24" stroke-width="10"/>
      <circle cx="112" cy="436" r="9" fill="#d9a441"/><circle cx="136" cy="436" r="9" fill="#d9a441"/>
      <rect x="-230" y="500" width="346" height="40" rx="10" fill="#fffaf1" stroke="#e2d2bb" stroke-width="3"/>
      <rect x="-226" y="530" width="342" height="10" fill="#3a2a24"/>
      <rect x="-222" y="466" width="96" height="40" rx="18" fill="#fffaf1" stroke="#e2d2bb" stroke-width="3"/>
      <g class="blanket-on"><path d="M-150,506 Q-140,450 -60,456 Q20,450 60,474 Q104,474 116,506 V540 H-150Z" fill="url(#quilt)" stroke="#5d7da0" stroke-width="3"/></g>
      <g class="blanket-off"><path d="M30,506 Q36,476 70,478 Q108,480 116,506 V540 H30Z" fill="url(#quilt)" stroke="#5d7da0" stroke-width="3"/></g>
    </g>
    ${sleeper(man2, -176, 452)}
    <g transform="translate(${MX},0)">
      <ellipse cx="0" cy="315" rx="108" ry="134" fill="#b4643a"/><ellipse cx="0" cy="315" rx="96" ry="122" fill="url(#glass2)"/>
      <path d="M-30,470 h60 l-10,130 h-40z" fill="#fffaf1" stroke="#e2d2bb" stroke-width="3"/>
      <path d="M-100,456 q100,50 200,0 v-8 h-200z" fill="#fffaf1" stroke="#e2d2bb" stroke-width="3"/>
      <rect x="-8" y="430" width="16" height="20" rx="3" fill="#c9c2b6"/>
      <rect x="54" y="424" width="16" height="28" rx="3" fill="#cfe6e3"/><rect x="60" y="410" width="3" height="20" fill="#d9483b"/>
    </g>
    ${reflect('clip2')}
    ${who()}
  </svg>`;

  const sc3 = `
  <svg viewBox="-350 -300 1700 1000" preserveAspectRatio="xMidYMax slice" aria-hidden="true">
    <defs>
      <pattern id="slats" width="34" height="10" patternUnits="userSpaceOnUse"><rect width="34" height="10" fill="#efd3b3"/><rect x="30" width="4" height="10" fill="#dcb48a"/></pattern>
      <linearGradient id="city" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#9fc3e6"/><stop offset=".6" stop-color="#ffd2a6"/><stop offset="1" stop-color="#ffe7c2"/></linearGradient>
      <linearGradient id="glass3" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#fffaf2"/><stop offset="1" stop-color="#efdcc6"/></linearGradient>
      <filter id="glow"><feGaussianBlur stdDeviation="10"/></filter>
      <clipPath id="clip3"><rect x="${MX - 110}" y="168" width="220" height="296" rx="40"/></clipPath>
    </defs>
    <rect ${BG} fill="url(#slats)"/>
    <g transform="translate(-90,90)">
      <rect width="300" height="260" rx="14" fill="url(#city)"/>
      <circle cx="230" cy="70" r="26" fill="#fff4d6" opacity=".95"/>
      <g fill="#c98f7a"><rect x="10" y="150" width="46" height="110"/><rect x="62" y="100" width="40" height="160"/><rect x="108" y="170" width="54" height="90"/><rect x="168" y="120" width="36" height="140"/><rect x="210" y="180" width="80" height="80"/></g>
      <rect width="300" height="260" rx="14" fill="none" stroke="#f7efe4" stroke-width="12"/>
    </g>
    <g transform="translate(470,600)"><path d="M-40,0 l8,-70 h64 l8,70z" fill="#d9b48f"/>
      <g fill="#5f8a4a"><path d="M0,-70 q-70,-30 -80,-110 q50,30 80,110"/><path d="M0,-70 q60,-60 50,-150 q-40,60 -50,150"/><path d="M0,-70 q-20,-90 10,-170 q20,90 -10,170"/><path d="M0,-70 q70,-10 110,-70 q-60,10 -110,70"/></g></g>
    <rect x="-800" y="600" width="2800" height="200" fill="#d8ac80"/>
    <path d="M-800,640 H2000 M-800,670 H2000" stroke="#c99a6c" stroke-width="2"/>
    <!-- Nachttisch mit Lampe und Handy-Wecker -->
    <g transform="translate(-330,0)">
      <rect x="0" y="500" width="70" height="100" rx="8" fill="#b58a62"/><rect x="8" y="540" width="54" height="4" fill="#9a7250"/>
      <ellipse cx="35" cy="430" rx="60" ry="50" fill="#ffd79a" filter="url(#glow)" opacity=".7"/>
      <path d="M18,460 h34 l-6,-36 h-22z" fill="#fff1d6"/><rect x="32" y="460" width="6" height="40" fill="#8a6a50"/>
      <rect x="44" y="488" width="20" height="12" rx="3" fill="#2b1a12"/><rect x="47" y="490" width="14" height="8" rx="2" fill="#ef7d45" class="ring"/>
    </g>
    <!-- Boxspringbett mit Polsterkopfteil -->
    <g>
      <rect x="-256" y="370" width="40" height="170" rx="14" fill="#c9b8a6"/>
      <rect x="-250" y="510" width="380" height="60" rx="12" fill="#b58a62"/>
      <rect x="-240" y="570" width="12" height="30" fill="#7a5a40"/><rect x="110" y="570" width="12" height="30" fill="#7a5a40"/>
      <rect x="-244" y="488" width="368" height="30" rx="12" fill="#fbf6ef"/>
      <rect x="-218" y="456" width="100" height="40" rx="18" fill="#fbf6ef" stroke="#e7dccd" stroke-width="3"/>
      <g class="blanket-on"><path d="M-150,500 Q-140,446 -60,452 Q20,446 60,470 Q110,470 124,500 V520 H-150Z" fill="#e9dccb"/><path d="M30,456 Q80,466 124,500 V520 H90Z" fill="#8fa3a8"/></g>
      <g class="blanket-off"><path d="M40,500 Q46,470 80,472 Q118,474 124,500 V520 H40Z" fill="#e9dccb"/><path d="M80,474 Q110,480 124,500 V520 H96Z" fill="#8fa3a8"/></g>
    </g>
    ${sleeper(man3, -164, 444)}
    <g transform="translate(${MX},0)">
      <rect x="-118" y="160" width="236" height="312" rx="46" fill="#ffd79a" filter="url(#glow)" opacity=".9"/>
      <rect x="-114" y="164" width="228" height="304" rx="42" fill="#cfa77c"/>
      <rect x="-110" y="168" width="220" height="296" rx="40" fill="url(#glass3)"/>
      <rect x="-130" y="480" width="260" height="46" rx="10" fill="#8a5a3b"/>
      <ellipse cx="-20" cy="476" rx="70" ry="16" fill="#fbf7f2" stroke="#e2d2bb" stroke-width="3"/>
      <rect x="70" y="444" width="22" height="36" rx="5" fill="#2b1a12"/><circle cx="81" cy="462" r="7" fill="none" stroke="#ef7d45" stroke-width="3" class="ring"/>
    </g>
    ${reflect('clip3')}
    ${who()}
    <text x="${PX + 40}" y="172" text-anchor="end" class="hand-note n62">62.000 Bewegungen / Min.</text>
  </svg>`;

  const man1780 = { skin: '#f2c8a8', skinDark: '#d9a585', hair: 'wig', hairC: '#f4f1ea', band: '#2b1a12', top: '#3f5a7a', topShade: '#2f4560', vest: '#d9b45a', jabot: true, bottom: '#e9dcc0', bottomShade: '#d6c6a2', stockings: '#fbf8f1', shoe: '#1f1612', buckle: true, tool: 'bone' };
  const man1960 = { skin: '#e8b48e', skinDark: '#c99470', hair: 'side', hairC: '#1f1410', glasses: true, collar: true, top: '#4aa39b', topShade: '#357c76', bottom: '#6a5442', bottomShade: '#574434', shoe: '#2b1d16', tool: 'retro' };

  /* 1780: Georgianisches Schlafzimmer, Himmelbett, Waschtisch mit Krug, vergoldeter Spiegel */
  const sc1780 = `
  <svg viewBox="-350 -300 1700 1000" preserveAspectRatio="xMidYMax slice" aria-hidden="true">
    <defs>
      <pattern id="stripe4" width="44" height="44" patternUnits="userSpaceOnUse"><rect width="44" height="44" fill="#eef1de"/><rect x="0" width="14" height="44" fill="#dfe6c6"/><rect x="20" width="3" height="44" fill="#d3dcb6"/></pattern>
      <pattern id="boards4" width="160" height="40" patternUnits="userSpaceOnUse"><rect width="160" height="40" fill="#b98b5e"/><path d="M0,0 H160 M0,20 H160 M60,0 V20 M130,20 V40" stroke="#9c7149" stroke-width="3"/></pattern>
      <linearGradient id="gild" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#f6dc8e"/><stop offset=".5" stop-color="#d4a33f"/><stop offset="1" stop-color="#a87a26"/></linearGradient>
      <linearGradient id="glass4" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#fbf7ea"/><stop offset="1" stop-color="#e2dcc4"/></linearGradient>
      <linearGradient id="dawn4" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#b9cbe6"/><stop offset="1" stop-color="#fbe0bd"/></linearGradient>
      <radialGradient id="flame4"><stop offset="0" stop-color="#fff6c8"/><stop offset="1" stop-color="#ffc861" stop-opacity="0"/></radialGradient>
      <clipPath id="clip4"><ellipse cx="${MX}" cy="300" rx="84" ry="110"/></clipPath>
    </defs>
    <rect ${BG} fill="url(#stripe4)"/>
    <rect x="-800" y="410" width="2800" height="190" fill="#d6c19c"/>
    <rect x="-800" y="402" width="2800" height="12" fill="#b99a6a"/>
    <g fill="none" stroke="#bfa67c" stroke-width="4"><rect x="-700" y="440" width="300" height="130" rx="6"/><rect x="-360" y="440" width="300" height="130" rx="6"/><rect x="-20" y="440" width="300" height="130" rx="6"/><rect x="320" y="440" width="300" height="130" rx="6"/><rect x="660" y="440" width="300" height="130" rx="6"/><rect x="1000" y="440" width="300" height="130" rx="6"/><rect x="1340" y="440" width="300" height="130" rx="6"/></g>
    <g transform="translate(-160,110)">
      <rect width="190" height="230" rx="4" fill="url(#dawn4)"/>
      <path d="M0,80 Q60,60 100,74 T190,70 V230 H0Z" fill="#c7b9a0" opacity=".6"/>
      <path d="M63,0 V230 M127,0 V230 M0,77 H190 M0,153 H190" stroke="#f7f1e2" stroke-width="7"/>
      <rect width="190" height="230" rx="4" fill="none" stroke="#f7f1e2" stroke-width="12"/>
      <path d="M-30,-20 Q-10,110 -26,250 L18,250 Q2,120 30,-20Z" fill="#8f3b3b"/>
      <path d="M220,-20 Q200,110 216,250 L172,250 Q188,120 160,-20Z" fill="#8f3b3b"/>
      <rect x="-40" y="-30" width="270" height="18" rx="6" fill="url(#gild)"/>
    </g>
    <g transform="translate(520,190)">
      <ellipse rx="52" ry="64" fill="url(#gild)"/><ellipse rx="42" ry="54" fill="#3f4a3a"/>
      <circle cx="-4" cy="-10" r="18" fill="#e9d8c0"/><path d="M-30,40 Q-4,6 22,40Z" fill="#e9d8c0"/><path d="M-22,-22 Q-4,-40 16,-22 Q20,-8 14,-2 Q-4,-30 -22,-12Z" fill="#f4f1ea"/>
    </g>
    <rect x="-800" y="600" width="2800" height="200" fill="url(#boards4)"/>
    <!-- Himmelbett mit Vorhängen -->
    <g>
      <rect x="-266" y="300" width="18" height="300" rx="6" fill="#6b3f22"/><rect x="112" y="300" width="18" height="300" rx="6" fill="#6b3f22"/>
      <rect x="-280" y="282" width="424" height="30" rx="6" fill="#8f3b3b"/>
      <path d="M-280,312 q53,30 106,0 q53,30 106,0 q53,30 106,0 q53,30 106,0" fill="#8f3b3b"/>
      <path d="M-280,312 Q-250,420 -276,560 L-232,560 Q-220,420 -236,312Z" fill="#a24848"/>
      <rect x="-250" y="500" width="370" height="44" rx="10" fill="#fbf6ec" stroke="#e6dccb" stroke-width="3"/>
      <rect x="-244" y="540" width="358" height="14" fill="#6b3f22"/>
      <rect x="-232" y="466" width="96" height="40" rx="18" fill="#fbf6ec" stroke="#e6dccb" stroke-width="3"/>
      <path d="M30,504 Q36,474 70,476 Q108,478 120,504 V544 H30Z" fill="#c9a24e" stroke="#a5822f" stroke-width="3"/>
    </g>
    <g transform="translate(${MX},0)">
      <ellipse cx="0" cy="300" rx="100" ry="126" fill="url(#gild)"/><ellipse cx="0" cy="300" rx="84" ry="110" fill="url(#glass4)"/>
      <path d="M-18,168 q18,-26 36,0 q-18,-8 -36,0z" fill="url(#gild)"/>
      <rect x="-120" y="462" width="240" height="18" rx="6" fill="#7a4a2a"/>
      <path d="M-104,480 L-96,600 M104,480 L96,600" stroke="#6b3f22" stroke-width="12" stroke-linecap="round"/>
      <path d="M-70,444 Q0,488 70,444Z" fill="#fbf8f1" stroke="#9fb7d6" stroke-width="4"/>
      <path d="M-40,458 h80" stroke="#9fb7d6" stroke-width="3"/>
      <g transform="translate(-92,0)"><path d="M-12,462 q-6,-36 4,-52 l-6,-10 h28 l-6,10 q10,16 4,52z" fill="#fbf8f1" stroke="#9fb7d6" stroke-width="3"/></g>
      <g transform="translate(86,0)"><rect x="-6" y="410" width="12" height="44" rx="3" fill="#fbf3dc"/><path d="M0,410 q-7,-12 0,-24 q7,12 0,24z" fill="#ffb347"/><circle cx="0" cy="398" r="34" fill="url(#flame4)" opacity=".9"/><rect x="-16" y="452" width="32" height="8" rx="3" fill="url(#gild)"/></g>
    </g>
    ${reflect('clip4')}
    ${who()}
  </svg>`;

  /* 1960: Bad im Retro-Stil, Mintkacheln, rundes Chromspiegel, rosa Waschbecken */
  const sc1960 = `
  <svg viewBox="-350 -300 1700 1000" preserveAspectRatio="xMidYMax slice" aria-hidden="true">
    <defs>
      <pattern id="tile5" width="48" height="48" patternUnits="userSpaceOnUse"><rect width="48" height="48" fill="#c3ebe2"/><path d="M0,0 H48 M0,0 V48" stroke="#a2d6ca" stroke-width="3"/></pattern>
      <pattern id="wall5" width="90" height="90" patternUnits="userSpaceOnUse"><rect width="90" height="90" fill="#fdf4e3"/><g stroke="#f0c27a" stroke-width="2.4" stroke-linecap="round"><path d="M22,22 l0,-9 M22,22 l8,-5 M22,22 l8,5 M22,22 l0,9 M22,22 l-8,5 M22,22 l-8,-5"/></g><circle cx="67" cy="64" r="4" fill="#9fd3c8"/></pattern>
      <pattern id="floor5" width="60" height="60" patternUnits="userSpaceOnUse"><rect width="60" height="60" fill="#f6efe0"/><rect width="30" height="30" fill="#e8907a"/><rect x="30" y="30" width="30" height="30" fill="#e8907a"/></pattern>
      <linearGradient id="sky5" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#9cd3f0"/><stop offset="1" stop-color="#fde6c4"/></linearGradient>
      <linearGradient id="glass5" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#fbfdfd"/><stop offset="1" stop-color="#d9e9ea"/></linearGradient>
      <linearGradient id="chrome" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#f4f6f8"/><stop offset=".5" stop-color="#b9c2ca"/><stop offset="1" stop-color="#8e99a3"/></linearGradient>
      <clipPath id="clip5"><circle cx="${MX}" cy="300" r="100"/></clipPath>
    </defs>
    <rect ${BG} fill="url(#wall5)"/>
    <rect x="-800" y="380" width="2800" height="220" fill="url(#tile5)"/>
    <rect x="-800" y="370" width="2800" height="14" fill="#e8907a"/>
    <g transform="translate(-190,110)">
      <rect width="230" height="200" rx="30" fill="url(#sky5)"/>
      <circle cx="170" cy="54" r="22" fill="#fff4d0"/>
      <g fill="#9fb4c4"><rect x="16" y="120" width="40" height="80"/><rect x="62" y="96" width="34" height="104"/><rect x="104" y="136" width="58" height="64"/><rect x="168" y="110" width="44" height="90"/></g>
      <rect width="230" height="200" rx="30" fill="none" stroke="#fffaf1" stroke-width="12"/>
      <path d="M-26,-16 Q-6,90 -24,214 L22,214 Q6,90 26,-16Z" fill="#f4c95d"/><path d="M256,-16 Q236,90 254,214 L208,214 Q224,90 204,-16Z" fill="#f4c95d"/>
      <g fill="#fffaf1" opacity=".8"><circle cx="-8" cy="30" r="5"/><circle cx="4" cy="90" r="5"/><circle cx="-6" cy="150" r="5"/><circle cx="234" cy="40" r="5"/><circle cx="224" cy="100" r="5"/><circle cx="236" cy="160" r="5"/></g>
      <rect x="-34" y="-26" width="298" height="12" rx="6" fill="#d9763f"/>
    </g>
    <g transform="translate(540,190)">
      <g stroke="#d9763f" stroke-width="5" stroke-linecap="round"><path d="M0,-70 V-40 M0,40 V70 M-70,0 H-40 M40,0 H70 M-50,-50 l20,20 M30,30 l20,20 M50,-50 l-20,20 M-30,30 l-20,20"/></g>
      <circle r="36" fill="#fffaf1" stroke="#2b1a12" stroke-width="5"/><path d="M0,0 V-22 M0,0 L16,8" stroke="#2b1a12" stroke-width="4" stroke-linecap="round"/>
    </g>
    <rect x="-800" y="600" width="2800" height="200" fill="url(#floor5)"/>
    <!-- Flaches Teakholzbett -->
    <g>
      <rect x="-262" y="400" width="110" height="140" rx="20" fill="#a8683a"/>
      <rect x="-256" y="406" width="98" height="128" rx="16" fill="#e2a13b"/>
      <rect x="-256" y="520" width="390" height="40" rx="8" fill="#a8683a"/>
      <path d="M-240,560 l-10,40 M110,560 l10,40" stroke="#7a4a26" stroke-width="10" stroke-linecap="round"/>
      <rect x="-248" y="494" width="376" height="30" rx="10" fill="#fdf8ef"/>
      <rect x="-230" y="462" width="100" height="38" rx="18" fill="#fdf8ef" stroke="#eadfcc" stroke-width="3"/>
      <path d="M30,500 Q36,470 70,472 Q110,474 128,500 V524 H30Z" fill="#4aa39b"/><path d="M40,486 Q80,480 122,492" stroke="#f4c95d" stroke-width="5" fill="none"/>
    </g>
    <g transform="translate(${MX},0)">
      <circle cx="0" cy="300" r="116" fill="url(#chrome)"/><circle cx="0" cy="300" r="100" fill="url(#glass5)"/>
      <path d="M-26,476 h52 l-8,124 h-36z" fill="#f4b6c2" stroke="#e294a3" stroke-width="3"/>
      <path d="M-104,452 q104,58 208,0 v-10 h-208z" fill="#f4b6c2" stroke="#e294a3" stroke-width="3"/>
      <rect x="-6" y="420" width="12" height="24" rx="3" fill="url(#chrome)"/><path d="M-6,424 h-16" stroke="#b9c2ca" stroke-width="6" stroke-linecap="round"/>
      <g transform="translate(70,0)"><rect x="-14" y="420" width="28" height="22" rx="6" fill="#efe2c4" stroke="#bfa98a" stroke-width="2"/><rect x="-6" y="398" width="12" height="26" rx="4" fill="#efe2c4" stroke="#bfa98a" stroke-width="2"/></g>
    </g>
    ${reflect('clip5')}
    ${who()}
  </svg>`;

  /* ---------- Kapitel ---------- */
  const CH = [
    { kap: 'Kapitel 01 · Kauwurzel', jahr: 'ca. 3000 v. Chr.', y: -3000, text: 'Aufstehen, zum Bronzespiegel – und putzen mit der Kauwurzel vom Arakbaum.' },
    { kap: 'Kapitel 02 · Knochenbürste', jahr: '1780', y: 1780, text: 'London: Rindsknochen als Griff, Borsten vom Wildschwein – die erste Zahnbürste.' },
    { kap: 'Kapitel 03 · Nylonbürste', jahr: '1938', y: 1938, text: 'Rein ins Kachelbad: Nylon ersetzt die Tierborsten, die Handzahnbürste ist da.' },
    { kap: 'Kapitel 04 · Erste Elektrische', jahr: '1960', y: 1960, text: 'Mit Kabel und Brummen: die erste elektrische Zahnbürste kommt ins Bad.' },
    { kap: 'Kapitel 05 · Heute', jahr: 'Heute', y: 2026, text: 'Frischen Kopf aufstecken, Klick – 62.000 Bewegungen pro Minute.' }
  ];
  const NOTES = ['… 4.800 Jahre später …', '… 158 Jahre später …', '… 22 Jahre später …', '… und bis heute …'];
  const SCENES = [sc1, sc1780, sc2, sc1960, sc3];
  const MEN = [man1, man1780, man2, man1960, man3];
  const N = SCENES.length, LAST = N - 1;
  const pano = root.querySelector('.pano');
  pano.style.width = `${N * 100}%`;
  pano.innerHTML = SCENES.map((s, i) => `<div class="scene sleep" id="sc${i + 1}" style="width:${100 / N}%">${s}</div>`).join('');
  const scenes = [...pano.querySelectorAll('.scene')].map((el, i) => ({
    el, svg: el.querySelector('svg'), who: el.querySelector('.who'), fig: el.querySelector('.fig'), rfig: el.querySelector('.rfig'),
    man: MEN[i], state: '', pose: '', cam: -60
  }));
  scenes[LAST].el.classList.add('last');
  const kap = root.querySelector('.kap'), jahr = root.querySelector('.jahr'), txt = root.querySelector('.kap-text');
  const chips = [...root.querySelectorAll('.ch-chip')];
  const note = root.querySelector('.zeit-note');
  const stage = root.querySelector('.stage');

  /* Zeitplan in Sekunden. Szene 1: Schlafen → Aufstehen → Laufen → Putzen.
     Danach läuft die Figur ohne Schnitt weiter: Die Kamera zieht mit, an der Epochengrenze
     wechselt die Kleidung, und in der nächsten Szene kommt sie direkt am Spiegel an. */
  const SLEEP = 1.7, RISE = 2.3, WALK_END = 4.9, FIRST_END = 8.4;
  const TR = 5.6;      // Weg von Spiegel zu Spiegel
  const BRUSH = 3.4;   // Putzen in den mittleren Epochen
  const S = [0], A = [WALK_END];   // S[k]: Aufbruch in Epoche k · A[k]: Ankunft am Spiegel
  for (let k = 1; k < N; k++) { S[k] = k === 1 ? FIRST_END : A[k - 1] + BRUSH; A[k] = S[k] + TR; }
  const TOTAL = A[LAST] + 1.2 + .7 + 3.8;
  const ease = x => x < .5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
  const easeWalk = x => x < .15 ? x * x / .3 : x > .85 ? 1 - (1 - x) * (1 - x) / .3 : (x - .075) / .85;   // sanft anlaufen und abbremsen
  const clamp01 = x => Math.max(0, Math.min(1, x));

  function posAt(t) {
    for (let k = 1; k < N; k++) {
      if (t < S[k]) return k - 1;
      if (t < A[k]) return k - 1 + ease((t - S[k]) / TR);
    }
    return LAST;
  }
  const yearAt = p => {
    const k = Math.min(LAST - 1, Math.floor(p)), f = p - k;
    if (p >= LAST - .02) return 'Heute';
    const r = Math.round(CH[k].y + (CH[k + 1].y - CH[k].y) * f);
    return r < 0 ? `${Math.abs(Math.round(r / 10) * 10)} v. Chr.` : (r < 1000 ? `${r} n. Chr.` : String(r));
  };

  // W = Breite des sichtbaren Ausschnitts in Szenen-Einheiten (eine Kamerafahrt = W)
  function sceneAt(i, t, W) {
    if (i < LAST && t >= S[i + 1]) {
      if (t >= A[i + 1]) return { state: 'gone', pose: 'walk', x: PX + W + 300, cam: 'mirror' };
      return { state: 'walk leave', pose: 'walk', x: PX + W * easeWalk(clamp01((t - S[i + 1]) / TR)), cam: 'mirror' };
    }
    if (i > 0) {
      if (t < S[i]) return { state: 'gone', pose: 'walk', x: PX - W - 300, cam: 'mirror' };
      if (t < A[i]) return { state: 'walk arrive', pose: 'walk', x: PX - W * (1 - easeWalk((t - S[i]) / TR)), cam: 'mirror' };
    } else {
      if (t < SLEEP) return { state: 'sleep', pose: 'walk', x: SX, cam: 'follow' };
      if (t < RISE) return { state: 'up', pose: 'walk', x: SX, cam: 'follow' };
      if (t < WALK_END) return { state: 'walk', pose: 'walk', x: SX + (PX - SX) * easeWalk((t - RISE) / (WALK_END - RISE)), cam: 'follow' };
    }
    const L = t - A[i];
    if (i < LAST) return { state: 'mirror brush', pose: 'brush', x: PX, cam: 'mirror' };
    if (L < 1.2) return { state: 'mirror pre', pose: 'pre', x: PX, cam: 'mirror' };
    if (L < 1.9) return { state: 'mirror click', pose: 'pre', x: PX, cam: 'mirror' };
    return { state: 'mirror brush', pose: 'brush', x: PX, cam: 'mirror' };
  }

  // Bildausschnitt: breite Bühne zeigt Bett bis Spiegel, schmale Bühne (Handy) folgt der Figur
  const mobile = matchMedia('(max-width: 760px)');
  function view() {
    const r = stage.getBoundingClientRect();
    const asp = r.width / Math.max(1, r.height);
    if (asp >= 1.2) { const H = Math.max(760, 1700 / asp); return { wide: true, H, W: asp * H }; }
    return { wide: false, H: 760, W: asp * 760 };
  }
  function frame(s, st, v, snap) {
    const { W, H } = v;
    let left;
    if (v.wide) left = 500 - W / 2;
    else {
      const lo = -280 + W / 2, hi = 1160 - W / 2;
      const fixed = /leave|arrive|gone/.test(st.state);   // beim Gang durch die Epochen steht die Kamera wie am Spiegel
      const target = st.cam === 'mirror' ? (PX + MX) / 2 : st.state === 'sleep' || st.state === 'up' ? -60 : st.x + 60;
      s.cam += (target - s.cam) * (snap || fixed ? 1 : .07);
      left = Math.max(lo, Math.min(hi, s.cam)) - W / 2;
    }
    s.left = left;
    const vb = `${left.toFixed(1)} ${700 - H} ${W.toFixed(1)} ${H}`;
    if (s.vb !== vb) { s.vb = vb; s.svg.setAttribute('viewBox', vb); }
  }

  /* ---------- Zeittunnel: kurze Zeitreise-Sequenz genau dort, wo die Figur die Epochengrenze überschreitet ---------- */
  const warp = document.createElement('canvas');
  warp.className = 'warp'; warp.setAttribute('aria-hidden', 'true');
  stage.appendChild(warp);
  const wx = warp.getContext('2d');
  const WARP = 1.1;   // halbe Dauer in Sekunden (gesamt gut 2 s)
  const STARS = Array.from({ length: 160 }, () => ({ a: Math.random() * Math.PI * 2, d: Math.random(), v: .5 + Math.random() * .9, c: ['#ffffff', '#a8ecff', '#ffd27a', '#d9bcff'][Math.random() * 4 | 0] }));
  const smooth = x => x <= 0 ? 0 : x >= 1 ? 1 : x * x * (3 - 2 * x);
  // Zeitpunkt (Anteil der Laufstrecke), an dem die Figur die rechte Bildkante ihrer Epoche erreicht
  function seamU(W, left) {
    const goal = 1 - (PX - left) / W;
    let lo = 0, hi = 1;
    for (let n = 0; n < 24; n++) { const m = (lo + hi) / 2; if (easeWalk(m) < goal) lo = m; else hi = m; }
    return (lo + hi) / 2;
  }
  function drawWarp(a, flash, cx, cy, time) {
    const r = stage.getBoundingClientRect(), dpr = Math.min(2, devicePixelRatio || 1);
    const w = r.width, h = r.height;
    if (a <= .002) { if (warp.dataset.on) { wx.clearRect(0, 0, warp.width, warp.height); delete warp.dataset.on; } return; }
    warp.dataset.on = '1';
    if (warp.width !== Math.round(w * dpr) || warp.height !== Math.round(h * dpr)) { warp.width = Math.round(w * dpr); warp.height = Math.round(h * dpr); }
    wx.setTransform(dpr, 0, 0, dpr, 0, 0);
    wx.clearRect(0, 0, w, h);
    const R = Math.hypot(w, h);
    // Tunnel: Mitte bleibt frei, außen wird es zu Nachthimmel
    const g = wx.createRadialGradient(cx, cy, 0, cx, cy, R * .75);
    g.addColorStop(0, 'rgba(255,248,230,0)');
    g.addColorStop(.18, `rgba(120,80,200,${.18 * a})`);
    g.addColorStop(.55, `rgba(40,28,110,${.62 * a})`);
    g.addColorStop(1, `rgba(10,8,40,${.86 * a})`);
    wx.fillStyle = g; wx.fillRect(0, 0, w, h);
    // Spiralarme, die sich in den Tunnel drehen
    wx.lineCap = 'round';
    for (let j = 0; j < 8; j++) {
      wx.beginPath();
      for (let s = 0; s <= 1.0001; s += .03) {
        const ang = j * Math.PI / 4 + s * 4.2 - time * 2.6, rad = 30 + s * s * R * .62;
        const x = cx + Math.cos(ang) * rad, y = cy + Math.sin(ang) * rad * .78;
        s ? wx.lineTo(x, y) : wx.moveTo(x, y);
      }
      wx.strokeStyle = j % 2 ? `rgba(168,236,255,${.32 * a})` : `rgba(255,210,122,${.32 * a})`;
      wx.lineWidth = 2 + 7 * a; wx.stroke();
    }
    // Lichtstreifen fliegen aus der Mitte heraus
    for (const st of STARS) {
      const d = (st.d + time * st.v * .8) % 1, r0 = 20 + d * d * R * .7, len = (8 + d * 190) * a;
      const x0 = cx + Math.cos(st.a) * r0, y0 = cy + Math.sin(st.a) * r0;
      wx.globalAlpha = a * Math.min(1, d * 4);
      wx.strokeStyle = st.c; wx.lineWidth = .8 + d * 2.6;
      wx.beginPath(); wx.moveTo(x0, y0); wx.lineTo(x0 + Math.cos(st.a) * len, y0 + Math.sin(st.a) * len); wx.stroke();
    }
    wx.globalAlpha = 1;
    // Zifferblatt mit rasenden Zeigern um die Figur
    const cr = Math.min(w, h) * .2 * (.75 + .35 * a);
    wx.save(); wx.translate(cx, cy); wx.globalAlpha = a;
    wx.shadowColor = 'rgba(255,220,150,.9)'; wx.shadowBlur = 18;
    wx.setLineDash([5, 13]); wx.lineWidth = 3;
    wx.lineDashOffset = -time * 90; wx.strokeStyle = '#ffd27a'; wx.beginPath(); wx.arc(0, 0, cr * 1.32, 0, Math.PI * 2); wx.stroke();
    wx.lineDashOffset = time * 140; wx.strokeStyle = '#a8ecff'; wx.beginPath(); wx.arc(0, 0, cr * 1.62, 0, Math.PI * 2); wx.stroke();
    wx.setLineDash([]);
    wx.strokeStyle = 'rgba(255,255,255,.95)'; wx.lineWidth = 3.5; wx.beginPath(); wx.arc(0, 0, cr, 0, Math.PI * 2); wx.stroke();
    for (let i = 0; i < 12; i++) {
      const an = i * Math.PI / 6;
      wx.lineWidth = i % 3 ? 2 : 4.5;
      wx.beginPath(); wx.moveTo(Math.cos(an) * cr * .84, Math.sin(an) * cr * .84); wx.lineTo(Math.cos(an) * cr * .97, Math.sin(an) * cr * .97); wx.stroke();
    }
    wx.lineWidth = 6; wx.beginPath(); wx.moveTo(0, 0); wx.lineTo(Math.cos(time * 9 - 1.57) * cr * .5, Math.sin(time * 9 - 1.57) * cr * .5); wx.stroke();
    wx.lineWidth = 3; wx.beginPath(); wx.moveTo(0, 0); wx.lineTo(Math.cos(time * 34 - 1.57) * cr * .78, Math.sin(time * 34 - 1.57) * cr * .78); wx.stroke();
    wx.restore();
    // Lichtblitz im Moment des Epochenwechsels
    if (flash > 0) {
      const f = wx.createRadialGradient(cx, cy, 0, cx, cy, R * .6);
      f.addColorStop(0, `rgba(255,255,255,${.95 * flash})`); f.addColorStop(.5, `rgba(255,246,220,${.7 * flash})`); f.addColorStop(1, `rgba(255,240,210,${.25 * flash})`);
      wx.fillStyle = f; wx.fillRect(0, 0, w, h);
    }
  }
  // Stärke der Sequenz, Blitz und Bildmitte der Figur für den aktuellen Zeitpunkt
  function warpState(v) {
    for (let k = 1; k < N; k++) {
      if (t < S[k] - 2 || t > A[k] + 2) continue;
      const s = scenes[k - 1], left = s.left ?? 500 - v.W / 2;
      const mid = S[k] + seamU(v.W, left) * TR, dt = (t - mid) / WARP;
      if (Math.abs(dt) >= 1) continue;
      const a = smooth((1 - Math.abs(dt)) / .45), flash = Math.max(0, 1 - Math.abs(t - mid) / .2);
      // Figur sitzt (in Bildschirmanteilen) dort, wo ihr Szenen-x im aktuellen Ausschnitt liegt
      const p = posAt(t), u = clamp01((t - S[k]) / TR);
      const xk = PX + v.W * easeWalk(u);
      const fx = (xk - left) / v.W + (k - 1 - p);
      const r = stage.getBoundingClientRect();
      return { a, flash, cx: fx * r.width, cy: (380 - (700 - v.H)) / v.H * r.height };
    }
    return null;
  }

  let t = 0, last = performance.now(), cur = -1;
  const still = matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (still) t = WALK_END + 2;   // ruhiges Standbild: Figur putzt am Spiegel

  function render(snap) {
    const p = posAt(t), v = view();
    pano.style.transform = `translate3d(${-p * 100 / N}%,0,0)`;
    const idx = Math.round(p);
    if (idx !== cur) {
      cur = idx;
      root.dataset.ch = idx;
      kap.textContent = CH[idx].kap; txt.textContent = CH[idx].text;
      [kap, txt].forEach(el => { el.classList.remove('in'); void el.offsetWidth; el.classList.add('in'); });
      chips.forEach((c, i) => c.setAttribute('aria-current', i === idx));
    }
    jahr.textContent = Math.abs(p - idx) < .02 ? CH[idx].jahr : yearAt(p);
    const moving = Math.abs(p - idx) > .04;
    note.classList.toggle('on', moving);
    if (moving) note.textContent = NOTES[Math.min(LAST - 1, Math.floor(p))];
    scenes.forEach((s, i) => {
      const st = sceneAt(i, t, v.W);
      if (st.pose !== s.pose) {
        s.pose = st.pose;
        const html = person({ ...s.man, pose: st.pose });
        s.fig.innerHTML = html; s.rfig.innerHTML = html;
      }
      if (st.state !== s.state) { s.state = st.state; s.el.className = 'scene ' + st.state + (i === LAST ? ' last' : ''); }
      s.who.setAttribute('transform', `translate(${st.x.toFixed(1)},600)`);
      frame(s, st, v, snap);
    });
    const ws = still ? null : warpState(v);
    drawWarp(ws ? ws.a : 0, ws ? ws.flash : 0, ws ? ws.cx : 0, ws ? ws.cy : 0, t);
    const fa = ws ? ws.a : 0;
    root.classList.toggle('warping', fa > .3);
    pano.style.filter = fa > .01 ? `saturate(${1 + fa * .5}) hue-rotate(${(fa * 28).toFixed(1)}deg) blur(${(fa * 1.4).toFixed(2)}px)` : '';
  }
  function loop(now) {
    if (!still) {
      t += Math.min(.1, (now - last) / 1000);
      if (t >= TOTAL) { t = 0; stage.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 900, easing: 'ease-out' }); render(true); }
    }
    last = now; render(false); requestAnimationFrame(loop);
  }
  chips.forEach((c, i) => c.addEventListener('click', () => { t = i === 0 ? .01 : A[i] + .01; render(true); }));
  addEventListener('resize', () => render(true));
  mobile.addEventListener?.('change', () => render(true));
  document.addEventListener('visibilitychange', () => { last = performance.now(); });
  render(true);
  requestAnimationFrame(loop);
})();
